// extracted by mini-css-extract-plugin
export default {"postPage":"mFmpGg","wrapper":"WzNrZ3","emptyState":"vkmZxG","recentPosts":"EfqCvP","aboveContentSlot":"oWLROm","pageBottomSlot":"iatMsC","mobileContainer":"nNF28C"};